import {
  correctiveActionAddComment,
  correctiveActionAddPublicComment,
  correctiveActionById,
  correctiveActionClose,
  correctiveActionPDF,
  correctiveActionPersonAddComment,
  correctiveActionPublicById,
  correctiveActionResolve,
  correctiveActionSendBack,
  correctiveActionSetPublicToUnderReview,
  correctiveActionsPDF,
  correctiveActionUpdateContacts,
  deleteCorrectiveAction,
  deleteCorrectiveActions,
  getAllCorrectiveActionComments,
  getAllCorrectiveActions,
  getAllOwnedCorrectiveActions,
  getAllPublicCorrectiveActionComments,
  getOnePersonsCorrectiveActions,
} from '../../../data/repositories/correctiveActions/CorrectiveActionsRepository'
import type { ICorrectiveActionContactsData, ICorrectiveActionSubmitData } from '../../interfaces/ICorrectiveAction'

export async function resolveCorrectiveAction(id: string, data: { description: string }) {
  return await correctiveActionResolve(id, data)
}

export async function getCorrectiveActions(query: string) {
  return await getAllCorrectiveActions(query)
}

export async function getCorrectiveActionsComment(id: string) {
  return await getAllCorrectiveActionComments(id)
}

export async function getPublicCorrectiveActionsComment(id: string, hash: string) {
  return await getAllPublicCorrectiveActionComments(id, hash)
}

export async function getPersonsCorrectiveActions(query: string) {
  return await getOnePersonsCorrectiveActions(query)
}

export async function getOwnedCorrectiveActions(query: string) {
  return await getAllOwnedCorrectiveActions(query)
}

export async function getCorrectiveActionById(id: string) {
  return await correctiveActionById(id)
}

export async function getCorrectivePublicActionById(id: string, hash: string) {
  return await correctiveActionPublicById(id, hash)
}

export async function addCommentOnCorrectiveAction(id: string, data: ICorrectiveActionSubmitData) {
  return await correctiveActionAddComment(id, data)
}

export async function updateCorrectiveActionContacts(id: string, data: ICorrectiveActionContactsData) {
  return await correctiveActionUpdateContacts(id, data)
}

export async function addPublicCommentOnCorrectiveAction(id: string, hash: string, data: ICorrectiveActionSubmitData) {
  return await correctiveActionAddPublicComment(id, hash, data)
}

export async function setPublicCorrectiveActionToUnderReview(hash: string, data: ICorrectiveActionSubmitData) {
  return await correctiveActionSetPublicToUnderReview(hash, data)
}

export async function personAddCommentOnCorrectiveAction(id: string, data: ICorrectiveActionSubmitData) {
  return await correctiveActionPersonAddComment(id, data)
}

export async function sendBackCorrectiveAction(id: string, data: ICorrectiveActionSubmitData) {
  return await correctiveActionSendBack(id, data)
}

export async function closeCorrectiveAction(id: string, data: ICorrectiveActionSubmitData) {
  return await correctiveActionClose(id, data)
}

export async function downloadCorrectiveActionPDF(id: string) {
  return await correctiveActionPDF(id)
}

export async function downloadCorrectiveActionsPDF(ids: string[]) {
  return await correctiveActionsPDF(ids)
}

export async function adminDeleteCorrectiveAction(correctiveActionId: string) {
  return await deleteCorrectiveAction(correctiveActionId)
}

export async function adminDeleteCorrectiveActions(correctiveActionIds: string[]) {
  return await deleteCorrectiveActions(correctiveActionIds)
}
